import {FormSubmitHandler} from "./submit/form-submit-handler.js";
import {ApiSubmitHandler} from "./submit/api-submit-handler.js";

/**
 * Factory function to create and configure a submit handler instance based on the given form and container.
 *
 * @param {Object} parentForm - The parent form object containing configuration, form data, and elements.
 * @param {Object} parentContainer - The parent container object associated with the form.
 * @return {Object} Returns an instance of a form or API submit handler, configured with the provided parameters and definitions.
 */
export function submitHandlerFactory(parentForm, parentContainer) {
    const map = {
        form: FormSubmitHandler,
        wwwencoded: FormSubmitHandler,

        api: ApiSubmitHandler,
        rest: ApiSubmitHandler,
        json: ApiSubmitHandler
    }

    const definition = (parentForm.configuration?.submit ?? parentForm.configuration?.callback ) ?? {type: "form"};
    const activator = map[definition.type ?? "form"];

    return Object.assign(new activator(parentForm.formData, parentContainer, parentForm.elements, parentForm.formId), definition);
}
